__turbopack_context__.v({
  "breadcrumbs": "CoreHero-module-scss-module__-ITu9q__breadcrumbs",
  "container": "CoreHero-module-scss-module__-ITu9q__container",
  "heading": "CoreHero-module-scss-module__-ITu9q__heading",
  "image": "CoreHero-module-scss-module__-ITu9q__image",
  "main": "CoreHero-module-scss-module__-ITu9q__main",
  "pattern": "CoreHero-module-scss-module__-ITu9q__pattern",
});
